import { useMemo } from 'react';

import type { resolvedAndErrorContentQuery$data } from '../../ui/article-search-component/search-dropdown/resolved-and-error-content/__generated__/resolvedAndErrorContentQuery.graphql';

const MIN_INPUT_CHAR_LENGTH = 1;

export type ArticleSearchResultItem = {
	id: string;
	title: string;
	type: string;
	url: string;
};

export type ArticleSearchReturnType = {
	articlesAndFolders: ArticleSearchResultItem[] | undefined;
	hasQueryError: boolean;
};

export const useArticleSearch = (
	searchResponse: resolvedAndErrorContentQuery$data,
	queryWord: string,
): ArticleSearchReturnType => {
	const entities = useMemo(
		() => searchResponse?.helpObjectStore_searchArticlesForSupportSite?.edges || [],
		[searchResponse?.helpObjectStore_searchArticlesForSupportSite],
	);
	const hasQueryError = Boolean(entities.find((edge: any) => edge?.node?.message));

	const articlesAndFolders = useMemo(() => {
		const edges = searchResponse.helpObjectStore_searchArticlesForSupportSite?.edges;

		if (edges) {
			const resultItems: ArticleSearchResultItem[] = edges
				.map(({ node }) => {
					const { id, title, contentType, urlInfo } = node;
					if (id && title && contentType && urlInfo?.shareUrl) {
						return {
							id,
							title,
							type: contentType.toString(),
							url: urlInfo.shareUrl,
						};
					}
					return null;
				})
				.filter((item): item is ArticleSearchResultItem => item !== null);

			return resultItems;
		}

		return undefined;
	}, [searchResponse.helpObjectStore_searchArticlesForSupportSite?.edges]);

	if (queryWord.length < MIN_INPUT_CHAR_LENGTH) {
		return { articlesAndFolders: undefined, hasQueryError: false };
	}

	return {
		articlesAndFolders,
		hasQueryError,
	};
};
